
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_geyug_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_geyug_1",
  "size-x-small": "awsui_size-x-small_1612d_geyug_58",
  "size-normal": "awsui_size-normal_1612d_geyug_66",
  "size-big": "awsui_size-big_1612d_geyug_74",
  "size-large": "awsui_size-large_1612d_geyug_82",
  "variant-normal": "awsui_variant-normal_1612d_geyug_90",
  "variant-disabled": "awsui_variant-disabled_1612d_geyug_93",
  "variant-inverted": "awsui_variant-inverted_1612d_geyug_96",
  "circle": "awsui_circle_1612d_geyug_108",
  "circle-left": "awsui_circle-left_1612d_geyug_136",
  "spinner-line-left": "awsui_spinner-line-left_1612d_geyug_1",
  "circle-right": "awsui_circle-right_1612d_geyug_141",
  "spinner-line-right": "awsui_spinner-line-right_1612d_geyug_1"
};
  